import axios from 'axios';

const API_BASE_URL = '/api';
const CLIENT_CACHE_MS = 30 * 60 * 1000;

let cachedRatesData = null;
let inflightRatesData = null;

const formatTimestamp = (fetchedAt) => {
  if (!fetchedAt) {
    return null;
  }

  const date = new Date(fetchedAt);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const pad = (value) => String(value).padStart(2, '0');
  return [
    date.getUTCFullYear(),
    '-',
    pad(date.getUTCMonth() + 1),
    '-',
    pad(date.getUTCDate()),
    ' ',
    pad(date.getUTCHours()),
    ':',
    pad(date.getUTCMinutes()),
    ':',
    pad(date.getUTCSeconds()),
  ].join('');
};

export async function loadRatesData() {
  if (
    cachedRatesData &&
    Date.now() - cachedRatesData.loadedAt < CLIENT_CACHE_MS
  ) {
    return cachedRatesData.data;
  }

  if (!inflightRatesData) {
    inflightRatesData = axios
      .get(`${API_BASE_URL}/rates-data`)
      .then((response) => {
        const data = {
          ...response.data,
          formatted: formatTimestamp(response.data.fetched_at),
        };
        cachedRatesData = {
          data,
          loadedAt: Date.now(),
        };
        window.exchangeRatesData = {
          timestamp: Math.floor(Date.parse(data.fetched_at) / 1000),
          base: data.base,
          rates: data.rates,
        };
        return data;
      })
      .finally(() => {
        inflightRatesData = null;
      });
  }

  return inflightRatesData;
}
